import { LuCreditCard, LuInfo, LuMapPin } from "react-icons/lu";

export const profileActions = [
  {
    title: "my_cards",
    href: "/my-cards",
    authRequired: true,
    icon: <LuCreditCard />,
  },
  {
    title: "my_adresses",
    href: "/my-addresses",
    authRequired: false,
    icon: <LuMapPin />,
  },
  {
    title: "about",
    href: "/about",
    authRequired: false,
    icon: <LuInfo />,
  },
];
